import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'
import { Button } from 'antd'
import LinkButton from './LinkButton'

const useStyles = createUseStyles({
  container: {
    textAlign: 'right',
  },
})

function AddNewItemButton({ itemName, path = null, icon = null, onClick = null }) {
  const classes = useStyles()
  return (
    <div className={classes.container}>
      {path && <LinkButton text={`Add new ${itemName}`} to={path} icon={icon} />}
      {onClick && <Button icon={icon} size="large" type="link" onClick={onClick}>
        {`Add new ${itemName}`}
      </Button>}
    </div>
  )
}

AddNewItemButton.propTypes = {
  itemName: PropTypes.string.isRequired,
  path: PropTypes.string,
  icon: PropTypes.node,
  onClick: PropTypes.func,
}

export default AddNewItemButton
